import { Injectable } from '@angular/core';
import { Attachment, ChatMessage, MessageCustomOptions } from '../model/chat.message';
import { isImageOrVideo } from '../../constants/constants';


@Injectable({
  providedIn: 'root'
})
export class ChatDataGroupingService {
  // Word Document (.doc, .docx)
  wordDocRegex = /\.(doc|docx)$/i;
  // Excel Workbook (.xls, .xlsx, .xlsm, .xlsb)
  excelWorkbookRegex = /\.(xls|xlsx|xlsm|xlsb)$/i;
  // PowerPoint Presentation (.ppt, .pptx)
  powerPointRegex = /\.(ppt|pptx)$/i;
  // Access Database (.accdb, .mdb)
  accessDatabaseRegex = /\.(accdb|mdb)$/i;
  // Comma-Separated Values (.csv)
  csvRegex = /\.csv$/i;
  // Tab-Separated Values (.tsv)
  tsvRegex = /\.tsv$/i;
  // Plain Text (.txt)
  textRegex = /\.txt$/i;
  // Google Sheets (.sheet)
  googleSheetsRegex = /\.sheet$/i;
  //ms office file
  msOfficeFileRegex = /\.(docx?|doc?|pptx?|xls?|xlsx?)$/i;
  constructor() { }

  // filter all attachments msgs which have sent continuously and keep it in one msg
  async filterForAttachments(messages: any[], messagesCount: number): Promise<any[]> {
  // async filterForAttachments(messages: ChatMessage[], messagesCount: number): Promise<any[]> {
    const currentUserID = localStorage.getItem('v8.0.27-chat-user') ? +(JSON.parse(localStorage.getItem('v8.0.27-chat-user'))?.userId) : 0;
    if (!currentUserID) {
      return messages;
    }
    const MAX_INTERVAL = 6 * 60 * 60 * 1000; //5 hours
    let currentUserMessages: ChatMessage[] = [];
    let oppositeUserMessages: ChatMessage[] = [];
    let modifiedMessages: ChatMessage[] = [];

    if (messages && messages.length != 0) {
      for (let i = 0; i < messages.length; i++) {

        const currentMsg = messages[i];
        if (currentMsg?.attachments?.length) {
          currentMsg.attachments[0].messageId = currentMsg.messageId;
        }
        // if (typeof currentMsg?.mentions == 'string') {
        //   currentMsg.mentions = JSON.parse(currentMsg?.mentions);
        // }
        // currentMsg.mentions = currentMsg.mentions?.map((mention: any) => typeof mention =='string' ? JSON.parse(mention) : mention);

        this.parsifyOptions(currentMsg);
        let optionsMessage: MessageCustomOptions = currentMsg?.options;
        // if (typeof currentMsg.options == 'string') {
        //   optionsMessage = JSON.parse(currentMsg?.options);
        //   messages[i].options= optionsMessage;
        //   if(messages[i]?.reply?.options){
        //     messages[i].reply.options= JSON.parse(messages[i].reply.options);
        //   }
        // }

        if (
          // messagesCount > 29 &&
          !optionsMessage?.is_emoji &&
          !currentMsg?.isDeleted &&
          !currentMsg?.temporaryDeleted &&
          !currentMsg?.options?.forwarded &&
          currentMsg?.messageId != currentMsg?.options?.id &&
          currentMsg?.attachments?.length > 0 &&
          currentMsg?.attachments?.length < 2 &&
          isImageOrVideo(currentMsg?.attachments[0]) &&
          !currentMsg?.attachments[0]?.description?.trim()?.length &&
          currentMsg?.messageId !== currentMsg?.options?.id // Check messageId against options?.id
        ) {

          let copy: ChatMessage = JSON.parse(JSON.stringify(currentMsg));
          delete copy['attachments'];
          delete copy['attachments_BE'];
          delete copy['files'];
          const attaches = {
            ...currentMsg.attachments[0],
            ...copy
          }
          currentMsg.attachments = [];
          currentMsg.attachments.unshift(attaches as any);
          if (!currentMsg.attachments[0]?.options) {
            currentMsg.attachments[0].options = typeof currentMsg?.options == 'string' ? JSON.parse(currentMsg?.options) : (currentMsg?.options ?? {});;
            currentMsg.attachments[0].authorId = currentMsg.authorId ? currentMsg.authorId : null;
            currentMsg.attachments[0].id = currentMsg?.id;
            currentMsg.attachments[0].messageId = currentMsg?.messageId;
            currentMsg.attachments[0].reactions = currentMsg?.reactions ?? {};
          }
          const mergedAttachments: Attachment[] = [currentMsg.attachments[0]];
          const unmergedMessages: ChatMessage[] = [currentMsg];

          let j = i + 1;
          // let z= j-1;
          // if(messages[z]?.attachments?.length && !messages[z]?.attachments[0]?.messageId){
          //   messages[z].attachments[0].authorId = messages[z].authorId ? messages[z].authorId : '';
          //   messages[z].attachments[0].id = messages[z]?.id
          //   messages[z].attachments[0].messageId = messages[z]?.messageId;
          //   messages[z].attachments[0].reactions = messages[z]?.reactions ?? {};
          // }
          // let timeDifference:number;
          // if()
          while (
            // (!timeDifference || (timeDifference && timeDifference < MAX_INTERVAL)) &&
            j < messages.length &&
            messages[j]?.attachments?.length > 0 &&
            !(this.parseOptions(messages[j]?.options))?.is_emoji &&
            !messages[j]?.isDeleted &&
            !messages[j]?.temporaryDeleted &&
            !messages[j]?.options?.forwarded &&
            isImageOrVideo(messages[j]?.attachments[0]) &&
            !messages[j]?.attachments[1] &&
            messages[j]?.u?.id == currentMsg?.u?.id &&
            !messages[j]?.attachments[0]?.description?.trim()?.length
          ) {
            // if (typeof messages[j]?.mentions == 'string') {
            //   messages[j].mentions = JSON.parse(messages[j]?.mentions);
            // }
            // messages[j].mentions = messages[j].mentions?.map((mention: any) => typeof mention =='string' ? JSON.parse(mention) : mention);
            this.parsifyOptions(messages[j]);
            // Add AuthorID , Message ID and Simple ID from future Selection

            let copy: ChatMessage = JSON.parse(JSON.stringify(messages[j]));
            delete copy['attachments'];
            delete copy['attachments_BE'];
            delete copy['files'];
            const attaches = {
              ...messages[j].attachments[0],
              ...copy
            }
            messages[j].attachments = [];
            messages[j].attachments.unshift(attaches as any);
            messages[j].attachments[0].authorId = messages[j].authorId ? messages[j].authorId : null;
            messages[j].attachments[0].id = messages[j]?.id;
            messages[j].attachments[0].messageId = messages[j]?.messageId;
            messages[j].attachments[0].reactions = messages[j]?.reactions ?? {};
            messages[j].attachments[0].options = (messages[j]?.options && typeof messages[j]?.options == 'string') ? JSON.parse(messages[j]?.options) : (messages[j]?.options ?? {});

            const keys = Object?.keys(messages[j].attachments[0].reactions);
            for (let arrayName of keys) {
              for (let reaction of messages[j].attachments[0].reactions[arrayName]) {
                // const element = messages[j].attachments[0].reactions[arrayName][k];
                reaction.messageId = messages[j]?.messageId;
                reaction.image_url = messages[j]?.attachments[0]?.image_url;
                reaction.video_url = messages[j]?.attachments[0]?.video_url;
                reaction.preview_lg_url = messages[j]?.options?.previewLg;
              }

            }
            // let indexOfAttachmentByOrder = mergedAttachments?.findIndex(a => a?.options?.order == messages[j].attachments[0]?.options?.order);
            // if (indexOfAttachmentByOrder >= 0) {
            //   const values: number[] = mergedAttachments.map(item => item.options?.order);
            //   const maxOrder = Math.max(...values);
            //   mergedAttachments[indexOfAttachmentByOrder].options?.order = maxOrder + 1;
            // }
            mergedAttachments.push(messages[j].attachments[0]);
            unmergedMessages.push(messages[j]);
            messages.splice(j, 1); // Remove the message with attachments
          }
          // Check if the current message belongs to the current user or the opposite user
          if (currentMsg?.u?.id == currentUserID) {
            if (unmergedMessages?.length < 4) {
              currentUserMessages.push(...unmergedMessages);
            }
            else {
              await mergedAttachments?.sort((a, b) => {
                const dt1 = Date.parse(a.ts as string);
                const dt2 = Date.parse(b.ts as string);
                if (dt1 > dt2) return 1; // Reverse the comparison due to using column-reverse on the chats array
                if (dt1 < dt2) return -1;
                return 0;
              });

              currentUserMessages.push({
                ...currentMsg,
                attachments: mergedAttachments,
              });
            }
          }
          else {
            if (unmergedMessages?.length < 4) {
              oppositeUserMessages.push(...unmergedMessages);
            }
            else {
              await mergedAttachments?.sort((a, b) => {
                // if (a?.options?.order && b?.options?.order && a?.options?.order !== b.options?.order) {
                //   return a.options?.order - b.options?.order;
                // }
                // return new Date(a.ts).getTime() - new Date(b.ts).getTime();
                const dt1 = Date.parse(a.ts as string);
                const dt2 = Date.parse(b.ts as string);
                if (dt1 > dt2) return 1; // Reverse the comparison due to using column-reverse on the chats array
                if (dt1 < dt2) return -1;
                return 0;
              });
              currentMsg.attachmentsOrdered = true;
              oppositeUserMessages.push({
                ...currentMsg,
                attachments: mergedAttachments,
              });
            }
          }
        } else {
          this.parsifyOptions(currentMsg);
          // Check if the current message belongs to the current user or the opposite user
          if (currentMsg?.u?.id == currentUserID) {
            currentUserMessages.push(currentMsg);
          } else {
            oppositeUserMessages.push(currentMsg);
          }
        }
      }

      modifiedMessages = [...currentUserMessages, ...oppositeUserMessages];

      // console.log('sortMessage:--', sortMessage);
    }
    return modifiedMessages;
  }


  parsifyOptions(currentMsg: ChatMessage): MessageCustomOptions {
    if (typeof currentMsg.options == 'string' && currentMsg?.options?.trim().length) {
      let optionsMessage = JSON.parse(currentMsg?.options);
      currentMsg.options = optionsMessage;
    }
    if (typeof currentMsg?.reply?.options == 'string' && currentMsg?.reply?.options?.trim().length) {
      currentMsg.reply.options = JSON.parse(currentMsg.reply.options);
    }
    return typeof currentMsg?.options === 'object' ? currentMsg?.options : {};
  }

  parseOptions(options: any): MessageCustomOptions {
    if (typeof options == 'string' && options?.trim().length) {
      return JSON.parse(options);
    }
    return options;
  }

  calculateAspectRatio(width: number, height: number): Promise<{ aspectWidth: number, aspectHeight: number }> {
    return new Promise((resolve, reject) => {
      const gcd = this.iterativeGcd(width, height);
      const aspectWidth = width / gcd;
      const aspectHeight = height / gcd;
      resolve({ aspectWidth, aspectHeight });
    });
  }

  private iterativeGcd(a: number, b: number): number {
    while (b !== 0) {
      const temp = b;
      b = a % b;
      a = temp;
    }
    return a;
  }

  captureDiv(div: HTMLElement): Promise<any> {
    return new Promise((resolve, reject) => {
      try {
        if (div) {
          const canvas = document.createElement('canvas');
          const context = canvas.getContext('2d');
          // Set canvas dimensions to match the div
          canvas.width = div.clientWidth;
          canvas.height = div.clientHeight;
          // Create an image element
          const img = new Image();
          const data = new XMLSerializer().serializeToString(div);
          const svg = new Blob([data], { type: 'image/svg+xml;charset=utf-8' });
          const url = URL.createObjectURL(svg);
          img.onload = () => {
            // Draw the image onto the canvas
            context?.drawImage(img, 0, 0);
            URL.revokeObjectURL(url);
            // Convert the canvas to a data URL
            const imgData = canvas.toDataURL('image/png');
            resolve(imgData);
          };
          img.onerror = (error) => {
            resolve(false)
          }
          img.onabort = (error) => {
            resolve(false)
          }

          img.src = url;
        }

      } catch (error) {
        resolve(false)
      }
    });
  }

  resizeImage(image: HTMLImageElement, canvasEle): string {
    const canvas = canvasEle.nativeElement;
    const ctx = canvas.getContext('2d');
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    ctx.drawImage(image, 0, 0, 18, 26);
    return canvas?.toDataURL('image/png') ?? '';
  }

  onBase64ImageChange(base64Image: string, canvas): Promise<string> {
    return new Promise((resolve, reject) => {
      try {
        const img = new Image();
        img.onload = () => {
          let thumbnail = this.resizeImage(img, canvas);
          resolve(thumbnail);
        };
        img.onerror = (error) => {
          resolve('')
        }
        img.onabort = (error) => {
          resolve('')
        }
        img.src = base64Image;
      } catch (error) {
        resolve('')
      }
    });
  }

  // Utility function
  convertBase64ToFile(base64String: string) {
    const filename = 'pdf-page1-preview.png';
    const contentType = 'image/png';
    let file = this.base64ToFile(base64String, filename, contentType);
    return file;
  }

  blobToFile(blob: Blob, fileName: string): File {
    const file = new File([blob], fileName, {
      type: blob.type,
      lastModified: Date.now(), // or you can use a specific timestamp
    });

    return file;
  }

  // Utility function
  base64ToFile(base64String: string, filename: string, contentType: string): File {
    // Clean the base64 string
    const cleanedBase64String = base64String.replace(/\s/g, '');
    const byteString = atob(cleanedBase64String);
    const byteNumbers = new Array(byteString.length);
    for (let i = 0; i < byteString.length; i++) {
      byteNumbers[i] = byteString.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    return new File([byteArray], filename, { type: contentType });
  }

  dataURItoBlob(imageURI, mimeType, name: string) {
    //console.log('imageURI:',imageURI);
    const arr = imageURI.split(",");
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    const fileName = name + '.' + (mimeType ?? 'png');
    const file: File = new File([u8arr], fileName, { type: mimeType })
    console.log(file);
    return file;
  }

  generateVideoThumbnail(
    file: File,
    seekTo: number = 2,
    scale = 0.5
  ): Promise<{ thumbnailUrl: string; duration: number }> {
    return new Promise((resolve, reject: (reason: string) => void) => {
      const video = document.createElement('video');
      const canvas = document.createElement('canvas');
      const context = canvas.getContext('2d');
      const fileURL = URL.createObjectURL(file);
      video.src = fileURL;
      let duration = 0;
      video.addEventListener('loadeddata', () => {
        video.currentTime = Math.min(seekTo, video.duration - 0.1); // Prevent seeking beyond the video duration
      });
      video.addEventListener('seeked', () => {
        duration = video.duration;
        let videoWidth = video.videoWidth;
        let videoHeight = video.videoHeight;
        // Apply scaling
        const scaledWidth = videoWidth * scale;
        const scaledHeight = videoHeight * scale;
        canvas.width = scaledWidth;
        canvas.height = scaledHeight;
        context?.drawImage(video, 0, 0, scaledWidth, scaledHeight);
        const thumbnailUrl = canvas.toDataURL('image/png');
        URL.revokeObjectURL(fileURL); // Clean up the object URL
        if (thumbnailUrl) {
          resolve({ thumbnailUrl, duration });
        } else {
          reject('Failed to create a thumbnail');
        }
      });

      video.addEventListener('error', (error) => {
        URL.revokeObjectURL(fileURL); // Clean up the object URL
        reject(`Error generating thumbnail: ${error.message}`);
      });

      // Fallback in case seeking fails (e.g., video doesn't have enough buffered data)
      video.addEventListener('timeupdate', () => {
        if (video.currentTime >= seekTo) {
          video.pause();
          video.dispatchEvent(new Event('seeked'));
        }
      });
    });
  }

  // getVideoThumbnail(file: File): Promise<{ data: string; error?: string }> {
  //   return new Promise(async (resolve, reject) => {
  //     try {
  //       const snapShoter = new VideoSnapshot(file);
  //       let previewSrc = await snapShoter.takeSnapshot();
  //       const MAX_SIZE = PREVIEW_LG_MAX_SIZE;
  //       let quality = 0.9; //90%

  //       const base64Length = (base64: string) =>
  //         (base64.length - 'data:image/jpeg;base64,'.length) * 3 / 4;

  //       // Reduce the size while the base64 size is greater than 2KB
  //       while (base64Length(previewSrc) > MAX_SIZE && quality > 0) {
  //         previewSrc = await this.scaleDownBase64Image(previewSrc, 0.5);
  //         quality -= 0.1; // Reduce quality by 10% each time
  //       }
  //       resolve({ data: previewSrc });
  //     } catch (error) {
  //       resolve({ data: "", error: error?.message ?? error });
  //     }
  //   });
  // }

  reduceSize(base64: string, quality: number, MAX_SIZE: number): Promise<{ data: string; error?: string }> {
    return new Promise(async (resolve, reject) => {
      try {
        const base64Length = (base64: string) =>
          (base64.length - 'data:image/jpeg;base64,'.length) * 3 / 4;
        while (base64Length(base64) > MAX_SIZE && quality > 0) {
          base64 = await this.scaleDownBase64Image(base64, 0.5);
          quality -= 0.1; // Reduce quality by 10% each time
        }
        resolve({ data: base64 });
      } catch (error) {
        resolve({ data: "", error: error?.message ?? error });
      }
    });
  }

  // Helper function to reduce the size of a base64 image
  reduceImageSize(base64: string, quality: number): Promise<string> {
    return new Promise((resolve) => {
      const img = new Image();
      img.src = base64;

      img.onload = () => {
        const canvas = document.createElement('canvas');
        const context = canvas.getContext('2d');

        // Set canvas size to match the image size
        canvas.width = img.width;
        canvas.height = img.height;

        // Draw the image on the canvas
        context?.drawImage(img, 0, 0, canvas.width, canvas.height);

        // Reduce the image quality and convert to base64 again
        const newBase64 = canvas.toDataURL('image/jpeg', quality);
        resolve(newBase64);
      };

      img.onerror = () => {
        resolve(base64); // Fallback to original base64 if error
      };
    });
  }


  getVideoCover(file, seekTo = 0.0): any {
    console.log("getting video cover for file: ", file);
    return new Promise((resolve, reject) => {
      // load the file to a video player
      const videoPlayer = document.createElement('video');
      let url = URL.createObjectURL(file);
      videoPlayer.setAttribute('src', url);
      videoPlayer.load();
      videoPlayer.addEventListener('error', (ex) => {
        reject("error when loading video file" + ex);
      });
      // load metadata of the video to get video duration and dimensions
      videoPlayer.addEventListener('loadedmetadata', () => {
        // seek to user defined timestamp (in seconds) if possible
        if (videoPlayer.duration < seekTo) {
          reject("video is too short.");
          return;
        }
        // delay seeking or else 'seeked' event won't fire on Safari
        setTimeout(() => {
          videoPlayer.currentTime = seekTo;
        }, 0);
        // extract video thumbnail once seeking is complete
        videoPlayer.addEventListener('seeked', () => {
          console.log('video is now paused at %ss.', seekTo);
          // define a canvas to have the same dimension as the video
          const canvas = document.createElement("canvas");
          const width = videoPlayer.videoWidth;
          const height = videoPlayer.videoHeight;
          canvas.width = width;
          canvas.height = height;
          // draw the video frame to canvas
          const ctx = canvas.getContext("2d");
          ctx.drawImage(videoPlayer, 0, 0, canvas.width, canvas.height);
          // return the canvas image as a blob
          let duration = videoPlayer.duration;
          // URL.revokeObjectURL(file);
          let quality = this.getQuality(width, height);
          let src = this.takeSnapshot(videoPlayer);
          ctx.canvas.toBlob(
            blob => {
              resolve({ src, duration, quality });
            },
            "image/png",
            1
          );

          videoPlayer.addEventListener('error', (error) => {
            URL.revokeObjectURL(url); // Clean up the object URL
            reject(`Error generating thumbnail: ${error.message}`);
          });
        });
      });
    });
  }

  public takeSnapshot(_video: HTMLVideoElement) {
    const canvasElement = <HTMLCanvasElement>document.createElement('CANVAS');
    const video: HTMLVideoElement = _video;
    const context = canvasElement.getContext('2d');
    let w: number, h: number, ratio: number;
    ratio = video.videoWidth / video.videoHeight;
    w = video.videoWidth - 100;
    h = w / ratio;
    canvasElement.width = w;
    canvasElement.height = h;
    context.fillRect(0, 0, w, h);
    context.drawImage(video, 0, 0, w, h);
    const link = document.createElement('a');
    const dataURL = canvasElement.toDataURL();
    return dataURL;

  }

  formatStopwatchTime(timeInSeconds: number): string {
    const minutes = Math.floor(timeInSeconds / 60);
    const seconds = Math.floor(timeInSeconds % 60);

    // Pad with leading zeros if needed
    const minutesDisplay = minutes < 10 ? `0${minutes}` : `${minutes}`;
    const secondsDisplay = seconds < 10 ? `0${seconds}` : `${seconds}`;

    return `${minutesDisplay}:${secondsDisplay}`;
  }

  convertSecondsToMinutesAndSeconds(totalSeconds: number): string {
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = Math.floor(totalSeconds % 60);
    if ((!minutes && !seconds) || seconds == null || seconds == undefined)
      return "";
    return `'${minutes ?? '0'}:${seconds}'`;
  }
  getAudioDuration(file: File): Promise<{ duration: string }> {

    return new Promise(async (resolve, reject) => {
      let url = URL.createObjectURL(file)
      const audio = new Audio(url);
      // Get duration after the audio metadata is loaded
      audio.onloadedmetadata = (e) => {
        let time = this.convertSecondsToMinutesAndSeconds(audio.duration);
        resolve({ duration: time });
      };

      audio.onerror = () => {
        console.error('Error loading audio file.');
        URL.revokeObjectURL(url);
        resolve(null);
      };
      audio.onabort = () => {
        console.error('Error loading audio file.');
        URL.revokeObjectURL(url);
        resolve(null);
      }
    });
  }

  getQuality(width: number, height: number) {
    let quality = 'Unknown';
    //find quality format
    if (height >= 4320) {
      quality = '8K UHD';
    } else if (height >= 2160) {
      quality = '4K UHD';
    } else if (height >= 1080) {
      quality = 'Full HD';
    } else if (height >= 720) {
      quality = 'HD';
    } else if (height >= 480) {
      quality = 'SD';
    } else {
      quality = 'LSD';
    }
    return quality;
  }

  scaleDownBase64Image(base64: string, scale: number): Promise<string> {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.src = base64;

      img.onload = () => {
        const canvas = document.createElement('canvas');
        const context = canvas.getContext('2d');

        const scaledWidth = img.width * scale;
        const scaledHeight = img.height * scale;

        canvas.width = scaledWidth;
        canvas.height = scaledHeight;

        context?.drawImage(img, 0, 0, scaledWidth, scaledHeight);

        const scaledBase64 = canvas.toDataURL('image/png');
        resolve(scaledBase64);
      };

      img.onerror = (error: any) => {
        console.log('scaleDownBase64Image error', error);
        reject(`Error scaling image: ${error?.message}`);
      };
    });
  }

  getVideoData(file: File): Promise<{ duration: number, quality: string }> {
    return new Promise((resolve, reject) => {
      const video = document.createElement('video');
      video.preload = 'metadata';
      let quality = this.getQuality(video.width, video.height);
      let duration: number;
      video.onloadedmetadata = () => {
        duration = video.duration;
        window.URL.revokeObjectURL(video.src); // Free up memory
        resolve({ duration, quality });
      };

      video.onerror = (event) => {
        reject('Error loading video');
      };

      const reader = new FileReader();
      reader.onload = (e: any) => {
        video.src = e.target.result;
      };

      reader.readAsDataURL(file);
    });
  }

  //download file types
  formatToMimeType: { [key: string]: string } = {
    'png': 'image/png',
    'jpeg': 'image/jpeg',
    'jpg': 'image/jpeg',
    'gif': 'image/gif',
    'pdf': 'application/pdf',
    'xlsx': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'csv': 'text/csv',
    'txt': 'text/plain',
    //@zia Add other formats as needed
  };

  getFileExtension(mimeType: string): string {
    if (mimeType?.toLowerCase()?.includes('sheet')) {
      return 'xlsx';
    }

    switch (mimeType) {
      case 'image/png':
      case 'image/jpeg':
      case 'image/gif':
        return mimeType.split('/')[1]; // png, jpeg, gif
      case 'video/mp4':
      case 'video/webm':
      case 'video/ogg':
        return mimeType.split('/')[1]; // mp4, webm, ogg
      case 'application/pdf':
      case 'pdf':
        return 'pdf';
      case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
        return 'xlsx';
      case 'text/csv':
        return 'csv';
      case 'text/plain':
        return 'txt';
      default:
        return 'bin'; // Fallback extension
    }
  }

  formatDateToString(date: Date): string {
    if (!date)
      date = new Date();
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');

    let hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');

    const ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    const strTime = `${hours}.${minutes}.${seconds} ${ampm}`;

    return `${year}-${month}-${day} at ${strTime}`;
  }

  getAnchorDownloadLink(attaches: any, ext?: string): { url: string, title: string, format: string } {
    if (!attaches) {
      alert('File format not supported. report this error');
      return null;;
    }
    const supportedFormats = ['image', 'video', 'audio', 'docx', 'doc', 'txt', 'csv', 'xlsx', 'ppt'];
    let _format = attaches?.format?.toLowerCase() ?? ext?.toLowerCase();
    if (!_format) {
      return null;
    }
    for (const format of supportedFormats) {
      if (attaches[format + '_type']?.toLowerCase().includes(format?.toLowerCase()) || _format?.includes('pdf') || _format?.includes('plain') || _format?.includes('officedocument.spreadsheetml.sheet') ||
        _format?.includes('excel') || _format?.includes('powerpoint') || _format?.includes('sheet')) {
        let url: string = attaches[format + '_url'] ?? attaches['title_link'];
        let obj = { url: url, title: attaches?.title, format: attaches?.format ? attaches?.format : attaches[format + '_type'] }
        return obj;
      }
    }
    if (attaches['title_link']) {
      let obj = { url: attaches['title_link'], title: attaches?.title, format: attaches?.format }
      return obj;
    }
    return null;
  }

  // Check if a file is a CSV
  isExceFile(fileName: string): boolean {
    return this.csvRegex?.test(fileName) || this.excelWorkbookRegex?.test(fileName);
  }

  // Check if a file is a TSV
  isTSV(fileName: string): boolean {
    return this.tsvRegex?.test(fileName);
  }

  // Check if a file is a plain text file
  isTextFile(fileName: string): boolean {
    return this.textRegex?.test(fileName);
  }

  // Check if a file is a Google Sheets file
  isGoogleSheetsFile(fileName: string): boolean {
    return this.googleSheetsRegex?.test(fileName);
  }

  //isMSword File
  isMsWordFile(filename: string): boolean {
    return this.wordDocRegex?.test(filename);
  }

  // Check if a file is a MS Office Sheets file
  isMsOfficeFile(fileName: string): boolean {
    return (this.msOfficeFileRegex?.test(fileName) || this.csvRegex?.test(fileName) || this.excelWorkbookRegex?.test(fileName));
  }

  areNearlyEqual(width: number, height: number, tolerance: number = 0.05): boolean {
    const aspectRatio = width / height;
    return Math.abs(aspectRatio - 1) <= tolerance;
  }

  convertBlobToBase64(blob: Blob): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();

      reader.onloadend = () => {
        resolve(reader.result as string);
      };

      reader.onerror = (error) => {
        reject(error);
      };

      reader.readAsDataURL(blob);
    });
  }

  getAttachmentsOnBasisOfType(file: File | undefined, url: string | undefined, desc: string | undefined, title: string | undefined) {
    let type = file.type?.toLowerCase();
    let attachments = [];
    let _title = title?.length ? title : file?.name?.length ? file?.name : "";
    let obj = {
      ts: new Date(),
      title: _title,
      title_link: url,
      title_link_download: true,
      type: "file",
      descriptionMd: [
        {
          type: "PARAGRAPH",
          value: [
            {
              type: "PLAIN_TEXT",
              value: desc
            }
          ]
        }
      ],
      description: desc?.length ? desc?.trim() : "",
    };


    if (type?.includes('image')) {
      obj["image_url"] = url;
      obj["image_type"] = type;
      obj["image_size"] = file?.size;
      obj["image_preview"] = url;

    }
    else if (type?.includes('audio')) {
      obj["audio_url"] = url;
      obj["audio_type"] = type;
      obj["audio_size"] = file?.size;
      obj["audio_preview"] = url;
    }
    else if (type?.includes('video')) {
      obj["video_url"] = url;
      obj["video_type"] = type;
      obj["video_preview"] = url;
    }
    else if (type?.includes('pdf') || type?.includes('plain')) {
      if (type?.toLowerCase().includes('plain')) {
        obj["format"] = 'plain';
      }
      else {
        obj["format"] = 'pdf';
      }
      obj["type"] = 'file';
    }
    obj["title_link"] = url;
    const isMsOfficeFile = this.isMsOfficeFile(file.name);
    const fileType = file.type;
    if (isMsOfficeFile || fileType.includes('text') || fileType.includes('txt') || fileType === '') { //
      obj["format"] = type;
      obj["title_link"] = url;
      obj["type"] = type;
    }
    attachments?.push(obj);
    return attachments;
  }

  doComputeSize(options) {
    if (!options) {
      return null;
    }

    function calculateResponsiveSize(knownDimension: number, aspectRatioWidth: number, aspectRatioHeight: number, isWidthKnown: boolean): { width: number, height: number } {
      if (isWidthKnown) {
        const width = knownDimension;
        const height = (knownDimension / aspectRatioWidth) * aspectRatioHeight;
        return { width, height };
      } else {
        const height = knownDimension;
        const width = (knownDimension / aspectRatioHeight) * aspectRatioWidth;
        return { width, height };
      }
    }
    const knownWidth = options?.width;
    const aspectRatioWidth = options?.aspectWidth;
    const aspectRatioHeight = options?.aspectHeight;
    const responsiveSize = calculateResponsiveSize(knownWidth, aspectRatioWidth, aspectRatioHeight, true);
    return responsiveSize;

  }

  setStyle(file_attaches_sec: HTMLElement, width: number) {
    if (file_attaches_sec) {
      file_attaches_sec.style.setProperty(
        "--message-file-media-width",
        `${width}px`
      );
    }
  }

  setStyleReply(replyFileForSizing: HTMLElement, width: number) {
    if (replyFileForSizing) {
      replyFileForSizing.style.setProperty(
        "--reply-file-size",
        `${width}px`
      );
    }
  }

  addImageFullHeightClasses(image2: HTMLImageElement, image1: HTMLImageElement) {
    image1?.classList.add('h-fa');
    image2?.classList.add('h-fa');
  }

  getMsge(item, messages: ChatMessage[]): ChatMessage {
    let obj = messages?.find(element => element?.attachments?.length && element?.attachments[0]?.image_url == item?.image_url);
    return obj
  }

  getMessageStyles(attaches, message_file: ChatMessage, file_attaches_sec: HTMLElement, image2: HTMLImageElement, image1: HTMLImageElement, replyFileForSizing: HTMLDivElement) {
    let message = message_file ?? this.getMsge(attaches, []);
    const options = this.parsify(message?.options);
    let key1 = localStorage.getItem('key11');
    let key2 = localStorage.getItem('key22');
    if (key1 && key2 && message_file[key1] == key2) {
      let x;
    }
    if (!options?.width || !options?.height) {
      return {};
    }
    // //is 16:9 image
    const ratio = +(options?.width / options?.height)?.toFixed(2);
    if (ratio >= 1.77) {
      this.setStyle(file_attaches_sec, 330);
      this.setStyleReply(replyFileForSizing, 330);
      const style = {
        'width.px': '330',
        'height.px': ratio > 2 && ratio < 2.5 ? '140' : '185'
      };
      if (ratio >= 5) {
        style['height.px'] = '82';
      }
      if (ratio >= 2.9) {
        style['height.px'] = '84.0';
      }
      // if(!this.chatDataGroupingService.areNearlyEqual((+style['height.px']), image2?.height)){
      //   this.addImageFullHeightClasses(image1,image2);
      //  }
      return style;
    }
    // if (ratio >= 1 || ratio >= 1.5) {
    if (ratio >= 1 && ratio != 1.33 && !this.areNearlyEqual(options?.width, options?.height)) {
      // if(!this.chatDataGroupingService.areNearlyEqual(219, image2?.height)){
      //   this.addImageFullHeightClasses(image1,image2);
      //  }
      this.setStyle(file_attaches_sec, 330);
      this.setStyleReply(replyFileForSizing, 330);
      return {
        'width.px': '330',
        'height.px': ratio < 1.3 ? '286.069' : (ratio == 1.6 ? '206.063' : '219.062')
      };
    }
    if ((options?.width >= options?.height && options?.height > 300 && this.areNearlyEqual(options?.width, options?.height))
      || (ratio > 0.6 && ratio < 0.7) && options?.height > 120 && options?.width > 120) {
      this.setStyle(file_attaches_sec, 330);
      this.setStyleReply(replyFileForSizing, 330);
      // if(!this.chatDataGroupingService.areNearlyEqual(330, image2?.height)){
      //   this.addImageFullHeightClasses(image1,image2);
      //  }
      return {
        'width.px': '330',
        'height.px': '330'
      };
    }
    if (options?.width >= options?.height && options?.height > 200 && this.areNearlyEqual(options?.width, options?.height)) {
      this.setStyle(file_attaches_sec, 330);
      this.setStyleReply(replyFileForSizing, 330);
      // if(!this.chatDataGroupingService.areNearlyEqual(286, image2?.height)){
      //  this.addImageFullHeightClasses(image1,image2);
      // }
      return {
        'width.px': '330',
        'height.px': '286'
      };
    }
    //is 4:3 image
    if (+ratio?.toFixed(2) == 1.33) {
      this.setStyle(file_attaches_sec, 330);
      this.setStyleReply(replyFileForSizing, 330);
      // if(!this.chatDataGroupingService.areNearlyEqual(248, image2?.height)){
      //   this.addImageFullHeightClasses(image1,image2);
      //  }
      return {
        'width.px': '330',
        'height.px': '248'
      };
    }
    //is 6:13 image
    if (+ratio?.toFixed(2) <= 0.75) {
      this.setStyle(file_attaches_sec, 240);
      this.setStyleReply(replyFileForSizing, 240);
      // if(!this.chatDataGroupingService.areNearlyEqual(338, image2?.height)){
      //   this.addImageFullHeightClasses(image1,image2);
      //  }
      return {
        'width.px': '240',
        'height.px': '338.028'
      };
    }
    if (options?.height > options?.width && options?.height > 198 && options?.width > 300) {
      this.setStyle(file_attaches_sec, 330);
      this.setStyleReply(replyFileForSizing, 330);
      const _height = options?.height < 210 ? 198 : (options?.height > 348 ? 348 : options?.height);
      // if(!this.chatDataGroupingService.areNearlyEqual(_height, image2?.height)){
      //   this.addImageFullHeightClasses(image1,image2);
      //  }
      return {
        'width.px': '330',
        'height.px': _height.toString()
      };
    }
    // Constructing the ngStyle object
    if (options && options?.aspectWidth && options?.aspectHeight) {
      let wh = this.doComputeSize(options);
      this.setStyle(file_attaches_sec, wh.width);
      this.setStyleReply(replyFileForSizing, wh.width);
      // if(!this.chatDataGroupingService.areNearlyEqual(wh?.height, image2?.height)){
      //   this.addImageFullHeightClasses(image1,image2);
      //  }
      return {
        'width.px': '' + wh?.width,
        'height.px': '' + wh?.height
      };
    }
    this.setStyle(file_attaches_sec, options?.width);
    this.setStyleReply(replyFileForSizing, options?.width);
    return {
      'width.px': options?.width || 'initial',
      'height.px': options?.height || 'initial'
    };
  }

  parsify(options: any): MessageCustomOptions {
    if (typeof options == 'string' && options?.trim()?.length) {
      return JSON.parse(options);
    }
    return options ?? {};
  }

  getMessageVideoStyles(message: ChatMessage, imageInnerRef: HTMLDivElement, fileSizeDiv: HTMLElement, file_attaches_section: HTMLDivElement) {
    if (message[localStorage.getItem('key1')] == +localStorage.getItem('key2')) {
      let x; //for debugging purposes
    }
    const options = this.parsify(message?.options);
    if (!options?.width || !options?.height) {
      return {};
    }
    const { aw, ah } = { aw: +options?.width, ah: +options?.height }
    if (fileSizeDiv)
      fileSizeDiv.style.width = 'auto';
    if (ah > aw) {
      if (aw > 200 && ah >= 300) {
        this.setStyle(file_attaches_section, 240);
        return {
          'height.px': '338',
          'width.px': '240',
        };
      }
      this.setStyle(file_attaches_section, aw);
      return {
        'height.px': (ah - (aw - aw + 5)),
        'width.px': aw,
      };
    }

    if (aw > ah) {
      this.setStyle(file_attaches_section, aw);
      return {
        'height.px': '185',
        'width.px': aw,
      };

    }

    if (this.areNearlyEqual(aw, ah)) {
      this.setStyle(file_attaches_section, aw);
      return {
        'height.px': ah,
        'width.px': aw,
      };
    }

    let ratio = aw / ah;
    let result = ratio.toString().split('.')[1]?.substring(0, 2);
    ratio = +(ratio.toString().split('.')[0] + '.' + (result ?? ''));
    //is 4: 3 image (portrait)
    if (ratio == 1.77) {
      return {
        'height.px': '185'
      };
    }

    ////is 4: 3 image
    if (ratio >= 2.18) {
      return {
        'height.px': '338.08'
      };
    }

    if (options?.width && options?.height && options?.width >= options?.height && options?.height > 200) {
      return {
        'height.px': '330'
      };
    }

    //is 4:3 image
    if (ratio == 1.33) {
      return {
        'height.px': '248'
      };
    }
    //is 6:13 image
    if (ratio == 0.46) {
      // if(imageInnerRef)
      // imageInnerRef.style.backgroundSize='cover';
      return {
        'height.px': '338.028'
      };
    }

    if (options?.width && options?.height && options?.height > 198 && options?.width > 300) {
      return {
        'height.px': '198'
      };
    }

    // Constructing the ngStyle object
    if (options && options?.aspectWidth && options?.aspectHeight) {
      let wh = this.doComputeSize(options);
      return {
        'height.px': '' + wh?.height
      };
    }
    return {
      'width': 'initial',
      'height.px': options?.height || 'initial'
    };
  }

}